<div
  class="flex flex-col justify-center items-center gap-4 min-h-screen bg-[#0f2b5e] text-white text-center px-4">
  <h1 class="font-bold text-3xl">Access denied</h1>
  <p class="max-w-md text-white/80">
    @if (user()) {
      Your account ({{ user()?.email }}) doesn't have access to this page.
    } @else {
      Your account doesn't have access to this application.
    }
  </p>
  <button
    class="mt-2 px-4 py-2 border border-white rounded-2xl"
    data-cy="forbidden-logout"
    type="button"
    (click)="onLogout()">
    Sign out
  </button>
</div>
